import { useState, useEffect, useRef, forwardRef, useReducer } from "react";
import { toast } from "react-toastify";
import EquipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import EquipmentGroupContants from "../../../Constants/EquipmentGroupConstants";
import commonUtils from "../../../helpers/commonUtils";
import equipmentGroupStore from "../../../Stores/EquipmentGroupStore";
import ConfirmationPopUp from "../../MessageBox/ConfirmationPopUp";
import AllAttributePanel from "./AllAttributePanel";
import SelectedAttributePanel from "./SelectedAttributePanel";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import AppConstants from "../../../Constants/AppConstants";

/*------------------------------Reducer function to handle the selected Attribute in Right Panel Of PopOver of EgGroup ------------------------------------*/

function selectedAttributeReducer(state, action) {
  switch (action.type) {
    case "selectedFromDataBase": {
      const attribute = action.attributes.map((element, index) => {
        return {
          name: element.name,
          isDropdownMenue: element.isDropdownMenue,
          onAddFormular: element.onAddFormular,
          isEditable: element.isEditable,
          attributeID: element.attributeID,
          id: element.id,
          outPut: element.output,
          isMandatory: element.isMandatory,
          pos: element.pos,
          isReadOnly: element.isReadOnly,
          hasOptions: element.hasOptions,
          attributeOptions: element.attributeOptions,
          nameDisplay: element.nameDisplay,
        };
      });
      return attribute;
    }
    case "noRecordFound": {
      return [];
    }
    case "addFromLeftPanel": {
      return [
        ...state,
        {
          name: action.item.bezeichnung,
          onAddFormular: true,
          isEditable: true,
          attributeID: action.item.id,
          isDropdownMenue: action.item.isDropdownMenue,
          id: AppConstants.DEFAULT_GUID,
          outPut: "0",
          hasOptions: action.item.hasOptions,
          attributeOptions: action.item.attributeOptions,
          nameDisplay: action.item.nameDisplay,
        },
      ];
    }
    case "deleteFromRightPanel": {
      const filterItems = state.filter(
        (item, index) => item.name !== action.attributes.name,
      );
      return filterItems;
    }
    case "postining or checkbox changes": {
      return action.selectedAttribute;
    }
    case "Clear SelectedAttribute": {
      return [];
    }
    case "optionsListData": {
      const attribute = state.map((element, index) => {
        if (element.attributeID == action.Data.attrId) {
          element.attributeOptions = action.Data.optionList;
        }
        return element;
      });

      return attribute;
    }
  }
}

const SelectAttribute = forwardRef((props, ref) => {
  const {
    egDetails,
    equipmentGrpId,
    handleRef,
    newOptionList,
    handleCompleted,
  } = props.data;
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [deletedAttribute, setDeletedAttribute] = useState();
  const [standardAttributes, setStandardAttributes] = useState([]);
  const [saveButtonDisable, setSaveButtonDisable] = useState(false);
  const [resetFilterFiled, setresetFilterFiled] = useState(false);
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const equipmentId = useRef("");
  const saveAttribute = useRef("");
  const OptionsListPopUpRef = useRef(null);
  const selectedAttributeIntialItem = [];
  const [selectedAttribute, dispatchDemo] = useReducer(
    selectedAttributeReducer,
    selectedAttributeIntialItem,
  );
  const rightScroll = useRef();
  const leftScroll = useRef();

  const getStandardAttribute = (eqGroupId) => {
    setGlobalSpinner(true);
    EquipmentGroupActions.getAnlagegruppeStandardAttributes(eqGroupId);
  };

  const resetShowMessageOnPopUpFlag = () => {
    commonUtils.setShowMessageOnPopUp(false);
  };
  useEffect(() => {
    if (equipmentGrpId) {
      equipmentId.current = equipmentGrpId;
      getStandardAttribute(equipmentGrpId);
      setresetFilterFiled(true);
    }
  }, []);

  useEffect(() => {
    if (newOptionList !== "") {
      handleOptionsListPopUpSaveCallback(
        newOptionList["_attrId"],
        newOptionList["_optionList"],
      );
    }
  }, [newOptionList]);
  useEffect(() => {
    if (selectedAttribute.length === 0) {
      setSaveButtonDisable(false);
    } else {
      setSaveButtonDisable(true);
    }
  }, [selectedAttribute]);

  useEffect(() => {
    function getStandardAttributeSuccess() {
      const res = equipmentGroupStore.getStandardAttributes();

      if (res.anlagegruppeStandardAttributeModels.length > 0) {
        setStandardAttributes(res.anlagegruppeStandardAttributeModels);
      } else {
        setStandardAttributes([]);
      }

      if (res.anlagegruppeStandardAttributeSaveUpdateModels.length > 0) {
        const items = res.anlagegruppeStandardAttributeSaveUpdateModels;

        dispatchDemo({ type: "selectedFromDataBase", attributes: items });
        saveAttribute.current = items;
      } else {
        dispatchDemo({ type: "noRecordFound" });
      }
      handleCompleted(
        "AddAttribute",
        res.anlagegruppeStandardAttributeSaveUpdateModels.length > 0,
      );
      setGlobalSpinner(false);
    }

    function getStandardAttributeFailure() {
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_EQU_GUP_STANDARD_ATTRIBUTES_SUCCESS,
      getStandardAttributeSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_EQU_GUP_STANDARD_ATTRIBUTES_FAILURE,
      getStandardAttributeFailure,
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_EQU_GUP_STANDARD_ATTRIBUTES_SUCCESS,
        getStandardAttributeSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_EQU_GUP_STANDARD_ATTRIBUTES_FAILURE,
        getStandardAttributeFailure,
      );
    };
  }, []);

  useEffect(() => {
    function addOrUpdateStandardAttributesSuccess() {
      const res = equipmentGroupStore.getAddOrUpdateStandardAttributes();

      if (res) {
        getStandardAttribute(equipmentId.current);
        toast.success(localization.standardAttributeAddedSuccess);
      }
    }

    function addOrUpdateStandardAttributesFailure() {
      const res = equipmentGroupStore.getAddOrUpdateStandardAttributes();
      getStandardAttribute(equipmentId.current);
      toast.error(res);
      dispatchDemo({ type: "noRecordFound" });
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADDORUPDATE_EQU_GUP_STANDARD_ATTRIBUTES_SUCCESS,
      addOrUpdateStandardAttributesSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADDORUPDATE_EQU_GUP_STANDARD_ATTRIBUTES_FAILURE,
      addOrUpdateStandardAttributesFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADDORUPDATE_EQU_GUP_STANDARD_ATTRIBUTES_SUCCESS,
        addOrUpdateStandardAttributesSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADDORUPDATE_EQU_GUP_STANDARD_ATTRIBUTES_FAILURE,
        addOrUpdateStandardAttributesFailure,
      );
    };
  }, []);

  useEffect(() => {
    function removeAnlagegruppeStandardAttributesSuccess() {
      getStandardAttribute(equipmentId.current);
      toast.success(localization.removeStandardAttributeSuccess);
      setGlobalSpinner(false);
    }

    function removeAnlagegruppeStandardAttributesFailure() {
      const res = equipmentGroupStore.getRemoveStandardAttributesToEquGup();
      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.REMOVE_STANDARD_ATTRIBUTES_EQU_GRP_SUCCESS,
      removeAnlagegruppeStandardAttributesSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.REMOVE_STANDARD_ATTRIBUTES_EQU_GRP_FAILURE,
      removeAnlagegruppeStandardAttributesFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.REMOVE_STANDARD_ATTRIBUTES_EQU_GRP_SUCCESS,
        removeAnlagegruppeStandardAttributesSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.REMOVE_STANDARD_ATTRIBUTES_EQU_GRP_FAILURE,
        removeAnlagegruppeStandardAttributesFailure,
      );
    };
  }, []);

  function handleSelectedAttribute(attribute) {
    dispatchDemo({ type: "addFromLeftPanel", item: attribute });
  }

  function handleSaveButton() {
    setSaveButtonDisable(false);
  }

  function handleDeleteAttribute(attribute, attributeIndex) {
    if (attribute.pos) {
      setConfirmationPopUpOpen(true);
      setConfirmationPopUpMsg(localization.deleteConfirmation);
      setCallbackData({
        equGrpId: equipmentId.current,
        ID: attribute.id,
      });
      setEventType("REMOVE_STANDARD_ATTRIBUTES_EQU_GRP_SUCCESS");
    } else {
      dispatchDemo({ type: "deleteFromRightPanel", attributes: attribute });
      setDeletedAttribute(attribute);
    }
  }

  /* ....................Handling CheckBox Updation and Change in Position of Attribute....................... */

  function updateSelectedAttribute(selectedAttribute) {
    dispatchDemo({ type: "postining or checkbox changes", selectedAttribute });
  }

  /* ....................Handle Final Submition of Attribute....................... */

  function handleSaveAttribute(e) {
    e.preventDefault();
    const finalObject = selectedAttribute.map((Element, index) => {
      return {
        ID: Element.id,
        AttributeID: Element.attributeID,
        Name: Element.name,
        OnAddFormular: Element.onAddFormular,
        IsEditable: Element.isEditable,
        IsMandatory: Element.isMandatory,
        Pos: index,
        Output: "0",
        IsReadOnly: Element.isReadOnly,
        hasOptions: Element.hasOptions,
        attributeOptions: Element.attributeOptions,
      };
    });
    let standardAttributesData = {
      AnlagegruppeID: egDetails.id ? egDetails.id : equipmentGrpId,
      AnlagegruppeStandardAttributeSaveUpdateModels: finalObject,
    };
    setGlobalSpinner(true);
    dispatchDemo({ type: "noRecordFound" });
    EquipmentGroupActions.addOrUpdateAnlagegruppeStandardAttributes(
      standardAttributesData,
    );
  }

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "REMOVE_STANDARD_ATTRIBUTES_EQU_GRP_SUCCESS":
          setGlobalSpinner(true);
          EquipmentGroupActions.removeAnlagegruppeStandardAttributes(data.ID);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setresetFilterFiled(false);
    resetShowMessageOnPopUpFlag();
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);

    rightScroll.current.scrollTo({ top: 0 });
    leftScroll.current.scrollTo({ top: 0 });
  };

  function handleOptionsListPopUpCallback(attributeData) {
    if (equipmentGrpId) {
      handleRef(equipmentGrpId, attributeData);
    } else {
      OptionsListPopUpRef.current.handleLoad(egDetails.id, attributeData);
    }
  }

  function handleOptionsListPopUpSaveCallback(attrId, optionList) {
    dispatchDemo({
      type: "optionsListData",
      Data: { attrId: attrId, optionList: optionList },
    });
  }

  return (
    <>
      <div
        className="
        row ml-0 mr-0"
        style={{ backgroundColor: "#fff" }}
      >
        <div className="col">
          <h4 className="pt-2">{localization.configureAttribute}</h4>
        </div>
      </div>
      <div className="row panelcontainer m-1">
        <div className="col-6 table-wrapper-scroll-y p-0" ref={leftScroll}>
          <AllAttributePanel
            standardAttributes={standardAttributes}
            handleAttributeFunction={handleSelectedAttribute}
            deletedAttribute={deletedAttribute}
            resetFilterFiled={resetFilterFiled}
          />
        </div>
        <div className="col-6 table-wrapper-scroll-y p-0" ref={rightScroll}>
          <SelectedAttributePanel
            selectedAttribute={selectedAttribute}
            handleDeleteAttribute={handleDeleteAttribute}
            handleSaveButton={handleSaveButton}
            updateSelectedAttribute={updateSelectedAttribute}
            handleOptionsListPopUpCallback={handleOptionsListPopUpCallback}
          />
        </div>
      </div>
      <div className="modal-footer p-3">
        <button
          className="btn btn-lg btn-primary btn-block w-25 p-1"
          type="submit"
          onClick={handleSaveAttribute}
          disabled={!saveButtonDisable}
        >
          {localization.save}
        </button>
      </div>
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
});

export default SelectAttribute;

export function demoFunction(_value, _details) {
  SelectAttribute.handleOptionsListPopUpSaveCallback(_value, _details);
}
